<template>
  <div class="recommend_info">
    <div class="bg">
      <span class="tips">请选择您要推荐客户信息</span>
    </div>
    <div class="main">
      <div class="table">
        <van-form
          @submit="showModel"
          input-align="right"
          error-message-align="right"
        >
          <div class="must">
            <!-- 姓名 -->
            <van-popup-select
              v-if="$route.params.buyAgain"
              title="选择业主"
              @onSelect="selectUser"
              :columns="userList.map((res) => res.customerName)"
              :type="2"
              :disabled="userDisabled"
            >
              <van-field
                readonly
                clickable
                name="userName"
                :border="false"
                v-model="username"
                label="客户姓名"
                is-link
                placeholder="请选择业主"
                :rules="[
                  {
                    required: true,
                    message: '请选择业主',
                    trigger: 'onChange',
                  },
                ]"
              />
            </van-popup-select>
            <van-field
              v-if="!$route.params.buyAgain"
              v-model="username"
              @input="userNameTrim"
              name="userName"
              :border="false"
              label="客户姓名"
              placeholder="请输入客户姓名"
              :rules="[
                { validator: userName, message: '姓名长度在2-10个汉字之间' },
              ]"
            />
            <div class="line"></div>
            <!-- 性别 -->
            <van-field
              name="gender"
              label="性别"
              :border="false"
              :rules="[
                { required: true, message: '请选择性别', trigger: 'onChange' },
              ]"
            >
              <template #input>
                <van-radio-group v-model="gender" direction="horizontal">
                  <van-radio name="0" icon-size="14px">
                    <img
                      class="sex_icon"
                      :src="gender == '0' ? nan_select_icon : nan_unselect_icon"
                      alt
                    />
                    <template #icon="props">
                      <img
                        class="img-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </van-radio>
                  <van-radio name="1" icon-size="14px">
                    <img
                      class="sex_icon"
                      :src="gender == '1' ? nv_select_icon : nv_unselect_icon"
                      alt
                    />
                    <template #icon="props">
                      <img
                        class="img-icon"
                        :src="props.checked ? activeNvIcon : inactiveIcon"
                      />
                    </template>
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <div class="line"></div>
            <!-- 电话号码 -->
            <van-field
              :disabled="$route.params.buyAgain"
              v-model="mobile"
              type="number"
              name="mobile"
              :border="false"
              label="电话"
              placeholder="请输入手机号码"
              :rules="[
                { required: true, message: '请输入电话号码' },
                { pattern: /^1[3456789]\d{9}$/, message: '电话号码格式错误！' },
              ]"
            />

            <div class="line"></div>
            <van-field
              @click="
                () => {
                  this.cityshow = true;
                }
              "
              readonly
              clickable
              name="city"
              :border="false"
              v-model="projectValue.projectName"
              label="推荐项目"
              is-link
              placeholder="请选择项目"
              :rules="[
                {
                  required: true,
                  message: '请选择项目',
                  trigger: 'onChange',
                },
              ]"
            />
            <div class="line"></div>
            <!-- 置业顾问 -->
            <van-popup-select
              title="选择置业顾问"
              @onSelect="selectAdviser"
              :columns="adviserList"
              :adviserDisabled="adviserDisabled"
              :type="3"
            >
              <van-field
                class="adviser"
                readonly
                clickable
                :border="false"
                name="adviser"
                v-model="adviserValue.managerName"
                label="置业顾问"
                is-link
                placeholder="请选择置业顾问"
              />
            </van-popup-select>
            <div class="line"></div>
          </div>
          <div class="no-must">
            <!-- 备注 -->
            <van-cell v-model="message" :border="false">
              <template #default>
                <van-field
                  @input="reMarkHandle"
                  v-model="message"
                  type="textarea"
                  label="备注"
                  maxlength="120"
                  show-word-limit
                  name="message"
                  placeholder="还想说点什么"
                  input-align="left"
                />
              </template>
            </van-cell>
          </div>
          <div></div>
          <div class="btn">
            <van-button round block type="info" native-type="submit"
              >提交审核</van-button
            >
          </div>
          <div class="text_tips">
            <span>温馨提示:</span>
            <p>
              1.请正确填写被推荐人的姓名及手机号码，且与到访、认购及签约的姓名、手机号码保持一致；
            </p>
            <p>
              2.具体推荐政策与奖励等信息以各具体项目营销政策为准，且该政策将不时进行变更，请在推荐前与具体项目沟通确认，希望会平台不做任何承诺。
            </p>
          </div>
        </van-form>
      </div>
    </div>
    <!-- 推荐成功弹框 -->
    <van-popup
      v-model="showSuccess"
      round
      style="border-radius: 10px"
      :close-on-click-overlay="false"
    >
      <div class="tip_success">
        <div class="icon">
          <img class="success_icon" :src="success ? successIcon : failIcon" />
          <span class="tip_head">推荐{{ success ? "成功" : "失败" }}</span>
          <span v-if="!success" class="tip_content tip_content_line">{{
            failedMessage
          }}</span>
        </div>
        <div class="success_btn" @click="back">我知道了</div>
      </div>
    </van-popup>
    <!-- 选择城市项目弹框 -->
    <van-popup
      v-model="cityshow"
      position="bottom"
      :style="{ height: '50%', width: '100%' }"
    >
      <van-picker
        title="选择项目"
        show-toolbar
        :columns="cityProColumns"
        @change="cityProChange"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
    <!-- 积分规则更改弹框 -->
    <van-popup
      v-model="showScoreModel"
      class='scoreModel'
      style="border-radius: 10px"
      :close-on-click-overlay="false"
    >
      <div class="old_bring_new_wrap">
        <div class="old_bring_new_head">
          <img src="http://xwh-public.oss-cn-beijing.aliyuncs.com/dwwb/portal/project/1661312595826/head.png" />
        </div>
        <div class="old_bring_new_main">
            <div class="title">积分调整公告</div>
            <div class="content">
              <div>尊敬的业主：</div>
              <div>感谢您对新希望地产一如既往的支持，为了更好地为您服务，我们将从<span style="color: #BC2424;">2022年9月1日</span>起执行以下业主推荐积分发放标准：</div>
            </div>
            <div class="content1">
              <div class="item">
                <span class="item_title">【报备】</span>
                <span class="item_cont">老业主推荐朋友进行系统报备无积分发放；</span>
              </div>
              <div class="item">
                <span class="item_title">【到访】</span>
                <span class="item_cont">老业主推荐的新客户到访售楼部，并完成个人信息登记；老业主和新客户将分别得到500的希望云商城积分；</span>
              </div>
              <div class="item">
                <span class="item_title">【成交】</span>
                <span class="item_cont">新客户购买我们的产品并完成正式合同签订后，新客户将得到5000的希望云商城积分；</span>
              </div>
              <div class="item">
                <span class="item_title">【提示】</span>
                <span class="item_cont">除以上要求外，获取积分还需满足以下条件：新客户前期未到访过售楼部或被他人推荐报备过，并且您应根据要求的时间、步骤进行系统操作；若不符合任一条件的，我们有权取消积分赠送；</span>
              </div>
            </div>
            <div class="content2">其他积分权益、积分消耗规则不变，再次感谢您的推荐。</div>
          
        </div>
        <div class="old_bring_new_footer">
          <div class="okBtn" @click="clickBtn(1)">同意并继续</div>
          <div class="cancelBtn" @click="clickBtn(0)">不同意退出</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import loading from "@/components/loading";
import {
  Form,
  RadioGroup,
  Radio,
  Field,
  Popup,
  Toast,
  Dialog,
  Picker,
} from "vant";
import vanPopupSelect from "@/components/vanPopupSelect";
export default {
  components: {
    "van-form": Form,
    "van-radio": Radio,
    "van-radio-group": RadioGroup,
    "van-field": Field,
    "van-popup-select": vanPopupSelect,
    "van-popup": Popup,
    "van-dialog": Dialog,
    "van-picker": Picker,
    loading,
  },
  data() {
    return {
      showScoreModel: false,
      // 推荐失败
      showFailDialog: false,
      flag: true, // 防止重复点击
      showErrTips: false,
      timer: null, // 定时器参数
      timerFlag: null,
      activeIcon: require("../../common/images/recommend/gender_select.png"),
      inactiveIcon: require("../../common/images/recommend/gender_unselect.png"),
      activeNvIcon: require("../../common/images/recommend/gender_nv_select.png"),
      nan_select_icon: require("../../common/images/recommend/sex_nan_select.png"),
      nan_unselect_icon: require("../../common/images/recommend/sex_nan_unselect.png"),
      nv_select_icon: require("../../common/images/recommend/sex_nv_select.png"),
      nv_unselect_icon: require("../../common/images/recommend/sex_nv_unselect.png"),
      successIcon: require("../../common/images/recommend/recommend_success.png"),
      failIcon: require("../../common/images/recommend/recommend_failed.png"),
      props: { checked: null },
      cityList: [
        // {orgName: '成都', orgCode: 'SDASJD-789ASDA7S'}
      ],
      userList: [],
      projList: [
        // {projectName: '大连普食素', projectCode: 'SDA9SDA87SDA-ASDA8'}
      ],
      adviserList: [], // 置业顾问列表
      adviser: "", // 置业顾问
      adviserDisabled: true,
      showPicker: false,
      showSuccess: false, // 推荐成功弹框
      disabled: true,
      userDisabled: true,
      cityValue: "",
      projectValue: {},
      adviserValue: {},
      message: "",
      username: "",
      gender: "0",
      mobile: "",
      success: true,
      submitInfo: null,
      failedMessage: "",
      // 加载中
      loadingStatus: false,
      // 城市项目选择
      cityProColumns: [],
      cityshow: false,
      allCityProList: [
        // {
        //   cityCode: "1",
        //   cityName: "浙江",
        //   children: [
        //     { projectCode: "1-1", projectName: "杭州" },
        //     { projectCode: "1-12", projectName: "杭州df" },
        //   ],
        // },
        // {
        //   cityCode: "2",
        //   cityName: "福建",
        //   children: [
        //     { projectCode: "2-1", projectName: "fafg" },
        //     { projectCode: "2-12", projectName: "ggg" },
        //   ],
        // },
      ],
    };
  },
  created() {
    document.title = "我要推荐";
    if (this.$route.params.id) {
      this.$api.RecommendInfo({ id: this.$route.params.id }).then((res) => {
        this.username = res.body.presentee;

        this.gender = res.body.gender.toString();
        this.mobile = res.body.contactNumber;
        this.cityValue = res.body.orgName;
        this.projectValue.projectName = res.body.projectName;
        this.projectValue.projectCode = res.body.projectCode;
        this.adviserValue.id = res.body.adviserId;

        this.adviserValue.managerCode = res.body.adviserCode;

        this.adviserValue.managerName = res.body.adviserName;
        this.message = res.body.remark;

        this.getAdviserList(this.projectValue.projectCode);
      });
    } else if (this.$route.params.buyAgain) {
      document.title = "我要再购";
      this.$api.findPersonalData().then((res) => {
        this.username = res.body.customerName;
        // this.gender = res.body.gender.toString();
        this.mobile = res.body.contractPhone;
        this.getUserList();
      });
    }
    // 获取城市项目选项
    this.getCityProjList();
  },
  methods: {
    clickBtn(e) {
      this.showScoreModel = false;
      if (e === 1) this.onSubmit();
    },
    // 获取项目列表
    getCityProjList() {
      this.$api.getCityProjList().then((res) => {
        if (res.code === "0000" && res.body) {
          this.allCityProList = res.body;
          let citys = this.allCityProList.map((item) => item.cityName);
          let pro = this.allCityProList[0].children.map(
            (item) => item.projectName
          );
          this.cityProColumns = [{ values: citys }, { values: pro }];
        }
      });
    },
    // 城市项目选择变化
    cityProChange(picker, values) {
      let proNames = this.allCityProList
        .filter((item) => item.cityName === values[0])[0]
        .children.map((item) => item.projectName);
      picker.setColumnValues(1, proNames);
      this.$forceUpdate();
    },

    onConfirm(values, index) {
      this.cityshow = false;
      this.adviserDisabled = false;
      this.adviserValue = {};

      // 获取城市项目编码
      let { cityCode, cityName, children } = this.allCityProList.filter(
        (item) => item.cityName === values[0]
      )[0];
      let { projectCode, projectName } = children.filter(
        (item) => item.projectName === values[1]
      )[0];
      this.cityValue = cityName;
      this.projectValue.projectName = projectName;
      this.projectValue.projectCode = projectCode;
      this.getAdviserList(projectCode);
    },
    onCancel() {
      this.cityshow = false;
    },
    reMarkHandle(e) {
      let regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s]|\s/g;
      this.message = this.message.replace(regRule, "");
    },

    userNameTrim(e) {
      this.username = e.trim();
    },
    userName(val) {
      if (val.length > 20 || val.length < 2) {
        return false;
      }
      return true;
    },
    showModel(e) {
      this.showScoreModel = true;
      this.submitInfo = e;
    },
    // 提交推荐信息
    onSubmit() {
      let e = this.submitInfo;
      let adivser =
        JSON.stringify(this.adviserValue) === "{}"
          ? { id: "", managerCode: "", managerName: "" }
          : this.adviserValue;
      let params = {
        // type=wx or type=app
        type: this.$route.query.type,
        flag: this.$route.params.id ? 1 : 2,
        presentee: e.userName,
        gender: e.gender,
        contactNumber: e.mobile,
        orgName: this.cityValue,
        projectName: this.projectValue.projectName,
        projectCode: this.projectValue.projectCode,
        adviser_id: adivser.id,
        adviser_code: adivser.managerCode,
        adviser_name: adivser.managerName,
        remark: e.message,
        ifOldbeitnewRecommend: this.$route.params.buyAgain ? 3 : 1,
      };
      if (this.$route.params.id) {
        params.id = this.$route.params.id;
      }
      if (this.flag == true) {
        this.loadingStatus = true;
        this.flag = false;
        this.timerFlag = setTimeout(() => {
          this.flag = true;
        }, 1000);
        this.$api
          .setSaveInfo(params)
          .then((res) => {
            this.flag = true;
            clearTimeout(this.timerFlag);
            if (res.code === "0000") {
              this.failedMessage = "";
              this.showSuccess = true;
              this.success = true;

              // 与后端确认，并不是只有一种失败情况，失败的内容也是动态的，所以理论上不该只区分0007的状态
            } else if (res.code === "0007") {
              this.showSuccess = true;
              this.success = false;
              this.failedMessage = res.message;
            } else {
              this.showSuccess = true;
              this.success = false;
              this.failedMessage = res.message;
            }
            this.loadingStatus = false;
          })
          .catch((res) => {
            this.loadingStatus = false;
            this.showSuccess = true;
            this.success = false;
            this.failedMessage = (res.data && res.data.message) || res;
          });
      }
    },
    selectCity(e) {
      this.cityValue = e.value;
      this.disabled = false;
      this.projectValue = {};
      this.adviserValue = {};
      this.getProjList(e.value);
      this.projectValue = {};
      this.adviserValue = {};
    },

    selectUser(user) {
      this.username = user.value;
      this.mobile = this.userList.find(
        (res) => res.customerName === this.username
      ).contractPhone;
      this.userDisabled = false;
    },
    // 选择项目
    selectProject(e) {
      this.projectValue = e.value;
      this.adviserDisabled = false;
      this.adviserValue = {};
      this.getAdviserList(e.value.projectCode);
    },
    // 选择置业顾问
    selectAdviser(e) {
      this.adviserValue = e.value;
    },
    // 提交成功后返回首页
    back() {
      if (this.success) {
        this.$router.go(-1);
        clearTimeout(this.timer);
      } else {
        this.showSuccess = false;
      }
    },

    // 获取用户列表
    getUserList() {
      this.$api.getUserList().then((res) => {
        if (res.code === "0000") {
          this.userList = res.body;
          this.username = res.body[0].customerName;
          this.gender = res.body[0].gender.toString();
          this.mobile = res.body[0].contractPhone;
        }
      });
    },

    // 获取置业顾问列表
    getAdviserList(projCode) {
      this.$api.getAdviser({ projectCode: projCode }).then((res) => {
        if (res.code === "0000") {
          this.adviserList = res.body.concat([
            {
              id: "",
              managerName: "自动分配",
              managerCode: "",
            },
          ]);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend_info {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .bg {
    width: 100%;
    height: 248px;
    background-image: url("../../common/images/recommend/info_bg.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .tips {
      color: #fff;
      font-size: 28px;
      margin-top: 38px;
    }
  }
  .main {
    flex: 1;
    width: 690px;
    position: relative;
    .table {
      width: 690px;
      height: 900px;
      padding-top: 16px;
      box-sizing: border-box;
      // background: #f7f7f7;
      background: #fff;
      position: absolute;
      top: -150px;
      border-radius: 16px;
      .line {
        height: 1px;
        background: #ebedf0;
        margin: {
          left: 30px;
          right: 30px;
        }
      }
      .sex_icon {
        width: 32px;
        height: 38px;
      }
    }
    .btn {
      padding: {
        left: 16px;
        right: 16px;
      }
      margin-top: 50px;
      margin-bottom: 50px;
      font-size: 32px;
    }
    .text_tips {
      width: 100%;
      height: 200px;
      padding: 32px;
      box-sizing: border-box;
      color: rgba(169, 169, 169, 0.7);
      font-size: 28px;
      margin-bottom: 100px;
      p {
        margin-top: 10px;
        text-indent: 1em;
      }
    }
  }
  .tip_success {
    width: 540px;
    height: 730px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #333333;
      .success_icon {
        width: 374px;
        height: 372px;
        margin-bottom: 38px;
      }
      .tip_head {
        font-size: 52px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .tip_content {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        &.tip_content_line {
          margin-top: 12px;
          width: 264px;
        }
      }
    }
    .success_btn {
      width: 452px;
      height: 76px;
      background: #0d9869;
      color: #fff;
      font-size: 28px;
      text-align: center;
      line-height: 76px;
      border-radius: 50px;
    }
  }
  .dialog_fail {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 2;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      width: 540px;
      min-height: 730px;
      max-height: 830px;
      background: #ffffff;
      border-radius: 20px;
      display: flex;
      flex-flow: column;
      align-items: center;
      img {
        width: 374px;
        height: 372px;
      }
      .status {
      }
    }
  }

  .scoreModel {
    width: 85%;
    height: 80%;
    border-radius: 8px;
    overflow: hidden;
    .old_bring_new_wrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .old_bring_new_head {
      width: 100%;
      height: 160px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .old_bring_new_main {
      flex: 1;
      overflow-y: scroll;
    }
    .title {
      font-size: 40px;
      text-align: center;
      padding: 24px 0px 10px 0px;
      box-sizing: border-box;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .content {
      padding: 20px 40px;
      box-sizing: border-box;
      font-size: 28px;
      color: #666666;
    }
    .content1 {
      width: calc(100% - 40px);
      margin-left: 20px;
      border-radius: 16px;
      background: #F5F4F2;
      font-size: 26px;
      color: #666666;
      padding: 18px 24px 0px 10px;
      box-sizing: border-box;
    }
    .item {
      margin-bottom: 20px;
      display: flex;
    }
    .item_title {
      color: #333333;
      font-weight: 600;
    }
    .item_cont {
      flex: 1;
    }
    .content2 {
      padding: 0px 40px;
      box-sizing: border-box;
      margin-top: 20px;
      font-size: 28px;
      color: #666666;
    }

    .old_bring_new_footer {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .okBtn {
      width: 80%;
      padding: 24px 0px;
      text-align: center;
      font-size: 32px;
      color: #fff   ;
      box-sizing: border-box;
      background: #EEBF00;
      border-radius: 60px;
    }
    .cancelBtn {
      color: #999;
      font-size: 32px;
      margin-top: 20px;
      margin-bottom: 50px;
    }
  }
}
</style>
<style lang="scss">
.recommend_info {
  .van-form {
    position: relative;
  }
  .must {
    .van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder {
      color: rgba(150, 151, 153, 0.5);
    }
    .van-cell {
      height: 102px;
      align-items: center;
    }
    .van-field__label span::after {
      content: "*";
      color: red;
      margin-left: 5px;
    }
    .adviser {
      .van-field__label span::after {
        content: "";
        color: red;
        margin-left: 5px;
      }
    }
  }
  .no-must {
    .van-cell {
      padding: 16px;
      display: block;
    }
    .van-field__label {
      width: auto;
    }
    .van-field__value {
      border: 0.5px solid #f2f2f2;
      border-radius: 8px;
      height: 198px;
      margin-top: 24px;
      padding: {
        top: 5px;
        left: 10px;
      }
      box-sizing: border-box;
    }
  }
  .btn {
    .van-button--info {
      background: #0d9869;
      border: none;
    }
  }
}
</style>
